module.exports = __webpack_public_path__ + "static/img/four_03.d230af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_03.png
// module id = aV5b
// module chunks = 3